import {
  PAGE_ROUTE_ADD_CATEGORY_SOP,
  PAGE_ROUTE_ADD_PRODUCT_ITEM_SOP,
  PAGE_ROUTE_ADD_PRODUCT_SOP,
  PAGE_ROUTE_CREATE_ORDER_SOP,
  PAGE_ROUTE_DASHBOARD_SOP,
  PAGE_ROUTE_FORGOT_PASSWORD_SOP,
  PAGE_ROUTE_ISSUE_INVOICE_SOP,
  PAGE_ROUTE_MANAGE_COMPANY_SOP,
  PAGE_ROUTE_MANAGE_ORDER_SOP,
  PAGE_ROUTE_MANAGE_PROFILE_SOP,
  PAGE_ROUTE_MANAGE_STORES_SOP,
  PAGE_ROUTE_RECORD_PAYMENT_SOP
} from "@kivunova/kivufrontendcommon";
import type { SopHubCategory } from "../types";

/** Add new step-by-step guides here. The hub page lists every entry. */
export const SOP_HUB_CATEGORIES: SopHubCategory[] = [
  {
    id: "overview",
    titleKey: "sops-hub-category-overview-inventory",
    titleFallback: "Overview & inventory",
    entries: [
      {
        id: "dashboard",
        route: PAGE_ROUTE_DASHBOARD_SOP,
        titleKey: "sops-hub-entry-dashboard-title",
        titleFallback: "How to use the dashboard",
        descriptionKey: "sops-hub-entry-dashboard-description",
        descriptionFallback:
          "Read business metrics by store and date. For company admins and store managers."
      },
      {
        id: "add-category",
        route: PAGE_ROUTE_ADD_CATEGORY_SOP,
        titleKey: "sops-hub-entry-add-category-title",
        titleFallback: "How to add a category",
        descriptionKey: "sops-hub-entry-add-category-description",
        descriptionFallback:
          "Create product groups and subgroups so your catalog stays organised."
      },
      {
        id: "add-product",
        route: PAGE_ROUTE_ADD_PRODUCT_SOP,
        titleKey: "sops-hub-entry-add-product-title",
        titleFallback: "How to add a product",
        descriptionKey: "sops-hub-entry-add-product-description",
        descriptionFallback:
          "Create a catalog product with selling mode, category, base unit, and partial selling rules."
      },
      {
        id: "add-product-item",
        route: PAGE_ROUTE_ADD_PRODUCT_ITEM_SOP,
        titleKey: "sops-hub-entry-add-product-item-title",
        titleFallback: "How to add a product item",
        descriptionKey: "sops-hub-entry-add-product-item-description",
        descriptionFallback:
          "Record stock for an existing product, set prices, and print QR labels for each unit."
      }
    ]
  },
  {
    id: "orders",
    titleKey: "sops-hub-category-orders",
    titleFallback: "Orders",
    entries: [
      {
        id: "create-order",
        route: PAGE_ROUTE_CREATE_ORDER_SOP,
        titleKey: "sops-hub-entry-create-order-title",
        titleFallback: "How to create an order",
        descriptionKey: "sops-hub-entry-create-order-description",
        descriptionFallback:
          "Open Sales Orders, start a new sale, and choose the store and customer."
      },
      {
        id: "manage-order",
        route: PAGE_ROUTE_MANAGE_ORDER_SOP,
        titleKey: "sops-hub-entry-manage-order-title",
        titleFallback: "How to manage an order",
        descriptionKey: "sops-hub-entry-manage-order-description",
        descriptionFallback:
          "Add or scan products, edit the draft, review totals, and confirm with the customer."
      },
      {
        id: "issue-invoice",
        route: PAGE_ROUTE_ISSUE_INVOICE_SOP,
        titleKey: "sops-hub-entry-issue-invoice-title",
        titleFallback: "How to issue an invoice",
        descriptionKey: "sops-hub-entry-issue-invoice-description",
        descriptionFallback:
          "Send a bill to the customer after they agree to buy."
      },
      {
        id: "record-payment",
        route: PAGE_ROUTE_RECORD_PAYMENT_SOP,
        titleKey: "sops-hub-entry-record-payment-title",
        titleFallback: "How to record payment",
        descriptionKey: "sops-hub-entry-record-payment-description",
        descriptionFallback:
          "Log full or partial payments, then complete the sale."
      }
    ]
  },
  {
    id: "company",
    titleKey: "sops-hub-category-company",
    titleFallback: "Company",
    entries: [
      {
        id: "manage-stores",
        route: PAGE_ROUTE_MANAGE_STORES_SOP,
        titleKey: "sops-hub-entry-manage-stores-title",
        titleFallback: "How to manage stores",
        descriptionKey: "sops-hub-entry-manage-stores-description",
        descriptionFallback:
          "Set up branches, update store details, and manage staff, customers, and suppliers per location."
      },
      {
        id: "manage-company",
        route: PAGE_ROUTE_MANAGE_COMPANY_SOP,
        titleKey: "sops-hub-entry-manage-company-title",
        titleFallback: "How to manage your company",
        descriptionKey: "sops-hub-entry-manage-company-description",
        descriptionFallback:
          "Company admin guide for employees, business details, and subscriptions."
      }
    ]
  },
  {
    id: "account",
    titleKey: "sops-hub-category-account",
    titleFallback: "Account",
    entries: [
      {
        id: "forgot-password",
        route: PAGE_ROUTE_FORGOT_PASSWORD_SOP,
        titleKey: "sops-hub-entry-forgot-password-title",
        titleFallback: "How to reset a forgotten password",
        descriptionKey: "sops-hub-entry-forgot-password-description",
        descriptionFallback:
          "Request a reset by email, set a new password, then sign in again."
      },
      {
        id: "manage-profile",
        route: PAGE_ROUTE_MANAGE_PROFILE_SOP,
        titleKey: "sops-hub-entry-manage-profile-title",
        titleFallback: "How to manage your personal profile",
        descriptionKey: "sops-hub-entry-manage-profile-description",
        descriptionFallback:
          "Update your name, phone, photo, and password on your own account."
      }
    ]
  }
];
